import script from "./multiplecateView.vue?vue&type=script&setup=true&lang=js"
export * from "./multiplecateView.vue?vue&type=script&setup=true&lang=js"

import "./multiplecateView.vue?vue&type=style&index=0&id=a5c2fdbc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5c2fdbc"]])

export default __exports__